/* Ask the Conch — pull-string oracle (2026-06-11).
   Vanilla JS, transform/opacity only. Drag the bead >=40px and release (or plain-tap it)
   and she answers from a shuffle-bag deck. The 4th pull (per session) deals the purchase
   card. The closing-CTA conch reuses the same answer module as an easter egg.
   The question input is decorative by design — nothing is ever transmitted. */
(function () {
  'use strict';

  var ANSWERS = [
    { t: 'Maybe someday.', c: 'maybeSomeday' },
    { t: 'Yes.', c: 'yes' },
    { t: 'No.', c: 'no' },
    { t: 'Try asking again.', c: 'askAgain' },
    { t: "I don't think so.", c: 'iDontThinkSo' },
    { t: 'Neither.', c: 'neither' },
    { t: 'Nothing.', c: 'nothing' }
  ];
  /* her real voice — clip URLs injected by the section; arrays = random variant */
  var clipCache = {};
  function playClip(key) {
    try {
      var M = window.conchOracleClips || {};
      var src = M[key];
      if (Array.isArray(src)) src = src[Math.floor(Math.random() * src.length)];
      if (!src) return;
      if (!clipCache[src]) { clipCache[src] = new Audio(src); clipCache[src].preload = 'auto'; }
      var a = clipCache[src];
      a.currentTime = 0; a.volume = 0.85;
      a.play().catch(function () {});
    } catch (e) {}
  }
  var SPECIAL = "You've asked enough. It's yours. It was always yours.";
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- shuffle bag: no repeats until the deck is exhausted --- */
  var bag = [];
  function drawAnswer() {
    if (!bag.length) {
      bag = ANSWERS.slice();
      for (var i = bag.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = bag[i]; bag[i] = bag[j]; bag[j] = t;
      }
    }
    return bag.pop();
  }

  /* --- session pull counter (survives reloads, never nags repeat visitors) --- */
  function getPulls() {
    try { return parseInt(sessionStorage.getItem('conch_pulls') || '0', 10) || 0; } catch (e) { return 0; }
  }
  function setPulls(n) {
    try { sessionStorage.setItem('conch_pulls', String(n)); } catch (e) {}
  }
  function specialDealt() {
    try { return sessionStorage.getItem('conch_special') === '1'; } catch (e) { return false; }
  }
  function markSpecial() {
    try { sessionStorage.setItem('conch_special', '1'); } catch (e) {}
  }

  function shareFortune(answer, btn) {
    var text = 'I asked the Magic Conch. It said: "' + answer + '" — hailtheconch.com';
    if (navigator.share) {
      navigator.share({ text: text }).catch(function () {});
      return;
    }
    var done = function () {
      var orig = btn.textContent;
      btn.textContent = 'copied!';
      setTimeout(function () { btn.textContent = orig; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () {});
    }
  }

  /* --- add to cart through the same drawer flow product-form uses --- */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var cart = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    var cfg;
    if (typeof fetchConfig === 'function') {
      cfg = fetchConfig('javascript');
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete cfg.headers['Content-Type'];
    } else {
      cfg = { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
    }
    cfg.body = fd;
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) return; /* error payload — leave quietly */
        /* ritual first: it arms the drawer-open deferral so the beats stay visible */
        if (window.conchAtcRitual) window.conchAtcRitual(btn);
        if (cart && cart.renderContents) {
          /* product-form does this too — without it the drawer's open() looks for the
             empty-state container that renderContents just replaced, and trapFocus throws */
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {});
  }

  /* --- speech bubble plumbing (shared by oracle + closing CTA) --- */
  function showBubble(bubble, text, opts) {
    opts = opts || {};
    var answerEl = bubble.querySelector('.co-answer');
    var buyBtn = bubble.querySelector('.conch-oracle__buy');
    var shareBtn = bubble.querySelector('.co-share');
    answerEl.textContent = text;
    /* special card speaks a real conch answer too — the crowd-chant clip confused
       people who don't know the scene ("idek what it played") */
    playClip(opts.special ? 'yes' : (opts.clip || null));
    answerEl.classList.toggle('co-answer--special', !!opts.special);
    if (buyBtn) buyBtn.hidden = !opts.special;
    if (shareBtn) {
      shareBtn.hidden = !!opts.special || !!opts.noShare;
      shareBtn.onclick = function () { shareFortune(text, shareBtn); };
    }
    bubble.hidden = false;
    bubble.classList.remove('is-popping', 'is-fading');
    void bubble.offsetWidth; /* restart the animation */
    bubble.classList.add(reduced ? 'is-fading' : 'is-popping');
  }
  function hideBubble(bubble) {
    bubble.hidden = true;
    bubble.classList.remove('is-popping', 'is-fading');
  }

  function riseBubbles(container, anchorEl) {
    if (reduced) return;
    var cRect = container.getBoundingClientRect();
    var aRect = anchorEl.getBoundingClientRect();
    for (var i = 0; i < 3; i++) {
      var b = document.createElement('i');
      b.className = 'co-bub';
      b.style.left = (aRect.left - cRect.left + aRect.width * (0.3 + 0.2 * i)) + 'px';
      b.style.top = (aRect.top - cRect.top + aRect.height * 0.35) + 'px';
      b.style.setProperty('--bx', Math.round(Math.random() * 26 - 13) + 'px');
      b.style.animationDelay = (i * 110) + 'ms';
      container.appendChild(b);
      b.addEventListener('animationend', function (ev) { ev.target.remove(); });
    }
  }

  /* ============================ the oracle section ============================ */
  function initOracle(root) {
    var pullBtn = root.querySelector('.conch-oracle__pull');
    var line = root.querySelector('.co-line');
    var bead = root.querySelector('.co-bead');
    var img = root.querySelector('.conch-oracle__img');
    var bubble = root.querySelector('.conch-oracle__bubble');
    var shell = root.querySelector('.conch-oracle__shell');
    var input = root.querySelector('.conch-oracle__q');
    var buyBtn = root.querySelector('.conch-oracle__buy');
    var hint = root.querySelector('.conch-oracle__hint');
    if (!pullBtn || !line || !bead || !bubble) return;

    var REST_Y2 = 58;
    var busy = false;

    /* the mobile card sits over the question input — tapping the card (not its
       buttons) dismisses it so the input is reachable again */
    bubble.addEventListener('click', function (e) {
      if (e.target.closest('.conch-oracle__buy, .co-share')) return;
      hideBubble(bubble);
    });

    if (buyBtn) {
      buyBtn.textContent = root.dataset.buyLabel || 'Make it official — $49.95';
      buyBtn.addEventListener('click', function () { addToCart(root.dataset.variantId, buyBtn); });
    }

    function setPull(v) {
      line.setAttribute('y2', String(REST_Y2 + v));
      bead.setAttribute('transform', 'translate(0,' + v + ')');
    }

    /* damped spring back with overshoot (rAF; no library) */
    function springBack(from, then) {
      if (reduced) { setPull(0); if (then) then(); return; }
      var t0 = performance.now();
      (function frame(now) {
        var t = (now - t0) / 1000;
        var v = from * Math.exp(-6.5 * t) * Math.cos(13 * t);
        if (t > 0.55) { setPull(0); if (then) then(); return; }
        setPull(v);
        requestAnimationFrame(frame);
      })(t0);
    }

    function answer() {
      var n = getPulls() + 1;
      setPulls(n);
      if (hint) hint.style.display = 'none';
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      if (!reduced && img) {
        img.classList.add('is-wiggling');
        img.addEventListener('animationend', function h() {
          img.classList.remove('is-wiggling');
          img.removeEventListener('animationend', h);
        });
      }
      riseBubbles(shell, img || pullBtn);
      var special = n >= 4 && !specialDealt();
      var card = special ? null : drawAnswer();
      var text = special ? SPECIAL : card.t;
      if (special) markSpecial();
      setTimeout(function () { /* the suspense beat */
        showBubble(bubble, text, { special: special, clip: card && card.c });
        busy = false;
      }, reduced ? 50 : 600);
    }

    function firePull(fromVisual) {
      if (busy) return;
      busy = true;
      hideBubble(bubble);
      springBack(fromVisual || 0);
      answer();
    }

    /* plain tap / keyboard / reduced-motion path: auto-play the pull */
    function autoPlay() {
      if (busy) return;
      if (reduced) { firePull(0); return; }
      busy = true;
      hideBubble(bubble);
      var t0 = performance.now();
      (function down(now) {
        var t = Math.min(1, (now - t0) / 240);
        setPull(56 * (1 - Math.pow(1 - t, 2)));
        if (t < 1) { requestAnimationFrame(down); return; }
        busy = false;
        firePull(56);
      })(t0);
    }

    /* drag with elastic resistance */
    var dragging = false, startY = 0, maxMoved = 0, visual = 0, downAt = 0;
    pullBtn.addEventListener('pointerdown', function (e) {
      if (busy || reduced) return;
      dragging = true;
      startY = e.clientY;
      maxMoved = 0;
      visual = 0;
      downAt = performance.now();
      pullBtn.classList.add('is-engaged');
      try { pullBtn.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    pullBtn.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var delta = Math.max(0, e.clientY - startY);
      maxMoved = Math.max(maxMoved, delta);
      var d = Math.min(delta, 150);
      visual = Math.min(80, d * (1 - d / 300));
      setPull(visual);
    });
    function release(e) {
      if (!dragging) return;
      dragging = false;
      pullBtn.classList.remove('is-engaged');
      var delta = Math.max(0, (e.clientY || 0) - startY);
      var quickTap = maxMoved < 8 && performance.now() - downAt < 400;
      if (quickTap) { autoPlay(); return; }
      if (delta >= 40) { firePull(visual); } else { springBack(visual); }
    }
    pullBtn.addEventListener('pointerup', release);
    pullBtn.addEventListener('pointercancel', function () {
      if (!dragging) return;
      dragging = false;
      pullBtn.classList.remove('is-engaged');
      springBack(visual);
    });
    /* keyboard + reduced-motion activation (pointerdown is suppressed when reduced) */
    pullBtn.addEventListener('click', function () {
      if (reduced && !busy) firePull(0);
    });
    pullBtn.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !busy) { e.preventDefault(); autoPlay(); }
    });
    /* asking via the input also pulls — the answer still ignores the question */
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); autoPlay(); }
      });
    }
  }

  /* ============== the HERO shell: tap her, she answers (oracle folded in) ==============
     The Ask-the-Conch section and the pull string are gone — squeezing the main
     plush IS the interaction: squish (theme.liquid physics) + speech bubble with
     her matching voice line. Bubble auto-fades after 3s; the 4th squeeze deals the
     purchase card, which stays until tapped (it has the buy button).
     Waits for the plush-physics inline script to build .conch-tilt first. */
  function initHero() {
    var tries = 0;
    (function wait() {
      var wrap = document.querySelector('.featured-product .conch-tilt');
      if (!wrap) {
        if (++tries < 40) { setTimeout(wait, 100); }
        return;
      }
      buildHero(wrap);
    })();
  }

  function buildHero(wrap) {
    if (wrap.dataset.conchHero) return;
    wrap.dataset.conchHero = '1';
    /* tell the physics click handler the oracle speaks for her now */
    window.conchHeroAnswers = true;
    var img = wrap.querySelector('img');

    var bubble = document.createElement('div');
    bubble.className = 'conch-oracle__bubble conch-hero-bubble';
    bubble.setAttribute('role', 'status');
    bubble.setAttribute('aria-live', 'polite');
    bubble.hidden = true;
    bubble.innerHTML = '<p class="co-answer"></p>' +
      '<button type="button" class="conch-oracle__buy" hidden></button>';

    /* mobile: the hero's flex column absorbs in-flow growth inside the media
       wrapper, so the card lives at the TOP of the info column instead — plain
       block flow, pushes the glass panel down for real. Desktop keeps the card
       absolute above her head (anchored to the media wrapper). */
    var host = wrap.closest('.product__media-wrapper') ||
               (wrap.closest('.product__media') || wrap).parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    /* absolute overlay on every screen — the card floats in the water above
       her head and never shifts the layout under it */
    host.appendChild(bubble);

    var heroAtc = document.querySelector("button[name='add']");
    var buyBtn = bubble.querySelector('.conch-oracle__buy');
    buyBtn.textContent = 'Make it official — $49.95';
    buyBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      hideBubble(bubble);
      if (heroAtc) heroAtc.click();
    });

    var hideTimer = null;
    function fadeAway() {
      if (bubble.hidden) return;
      if (reduced) { hideBubble(bubble); return; }
      bubble.classList.remove('is-popping', 'is-fading');
      bubble.classList.add('is-hiding');
      bubble.addEventListener('animationend', function h(ev) {
        if (ev.animationName === 'co-bubble-out') {
          bubble.removeEventListener('animationend', h);
          bubble.classList.remove('is-hiding');
          bubble.hidden = true;
        }
      });
    }
    /* tap the card (not the buy button) to dismiss it early */
    bubble.addEventListener('click', function (e) {
      if (e.target.closest('.conch-oracle__buy')) return;
      clearTimeout(hideTimer);
      hideBubble(bubble);
    });

    var busy = false;
    wrap.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      clearTimeout(hideTimer);
      hideBubble(bubble);
      var n = getPulls() + 1;
      setPulls(n);
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      riseBubbles(wrap, img || wrap);
      var special = n >= 4 && !specialDealt();
      var card = special ? null : drawAnswer();
      var text = special ? SPECIAL : card.t;
      if (special) markSpecial();
      setTimeout(function () { /* a short suspense beat after the squish */
        bubble.classList.remove('is-hiding');
        showBubble(bubble, text, { special: special, clip: card && card.c });
        if (!special) { hideTimer = setTimeout(fadeAway, 3000); }
        busy = false;
      }, reduced ? 50 : 450);
    });
  }

  /* ============== closing-CTA easter egg: the bobbing conch answers too ============== */
  function initClosing() {
    var img = document.querySelector('.conch-closing__img');
    var closing = document.querySelector('.conch-closing');
    if (!img || !closing) return;
    var bubble = document.createElement('div');
    bubble.className = 'conch-oracle__bubble';
    bubble.setAttribute('role', 'status');
    bubble.setAttribute('aria-live', 'polite');
    bubble.hidden = true;
    bubble.innerHTML = '<p class="co-answer"></p>';
    closing.insertBefore(bubble, img.nextSibling);
    var timer = null;
    img.addEventListener('click', function () {
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      (function(){ var c = drawAnswer(); showBubble(bubble, c.t, { noShare: true, clip: c.c }); })();
      clearTimeout(timer);
      timer = setTimeout(function () { hideBubble(bubble); }, 3500);
    });
  }

  function init() {
    var root = document.querySelector('.conch-oracle');
    if (root) initOracle(root);
    initHero();
    initClosing();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
